module.exports = __webpack_public_path__ + "static/media/example.53b0910b.png";